function TokenMountIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentcolor"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M22.006 6v2.71c0 .472-.302.89-.75 1.04a1.005 1.005 0 01-1.17-.42l-1.12-1.79c-.13-.21-.46-.12-.46.13v3.58c0 .98-.39 1.86-1 2.53v5.97a1.25 1.25 0 01-2.5 0V15h-.25c-.21 0-.42-.03-.62-.06l-4.44-.74-1.12 2.01.712 3.55A1.037 1.037 0 018.27 21a1.559 1.559 0 01-1.525-1.238l-.74-3.512c-.03-.3 0-.6.16-.86l1.02-1.81a3.272 3.272 0 01-1.68-2.77c-.04.15-.06.37-.03.69.03.44.14 1.09.07 1.81-.04.72-.37 1.46-.79 1.95-.43.49-.9.83-1.4 1.09-.5.26-.89-.23-.7-.7.19-.47.38-.89.42-1.28.06-.37-.01-.67-.12-.94l-.53-1.13c-.21-.51-.47-1.25-.42-2.12.03-.85.5-1.96 1.39-2.57.9-.61 1.87-.69 2.66-.53.5.1 1.01.34 1.45.68.37-.17.8-.26 1.25-.26h5.75V7c0-2.21 1.79-4 4-4h3.5l-.89 1.34c.54.36.89.97.89 1.66z" />
    </svg>
  );
}

export default TokenMountIcon;
